import "./src/styles/global.css";
// import "@fontsource/poppins/700.css";

import * as React from "react";
import PageTransition from "./src/components/PageTransition";

// Prevent white flash on page navigation by setting dark background immediately
if (typeof window !== "undefined") {
  const style = document.createElement("style");
  style.innerHTML = `
    html, body, #___gatsby, #gatsby-focus-wrapper {
      background-color: #09090b !important;
      color: #fafafa !important;
    }
  `;
  document.head.appendChild(style);
}

export const wrapPageElement = ({ element, props }) => (
  <PageTransition element={element} location={props.location} />
);
